'use client';

import type { FullRescanRun } from '@terra/shared-contracts-applications';
import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { SettingsCard } from '../../SettingsCard';
import { SettingsRow } from '../../SettingsRow';
import { FullRescanStatus } from './FullRescanStatus';

export type FullRescanLastRunCardProps = {
  run: FullRescanRun;
};

export const FullRescanLastRunCard = ({ run }: FullRescanLastRunCardProps) => {
  const t = useTranslations('designSystem.scanEffort.fullRescan');

  return (
    <SettingsCard>
      <VStack alignItems="stretch" gap={3} w="full">
        <SettingsRow label={t('lastRun')} />
        <FullRescanStatus run={run} />
      </VStack>
    </SettingsCard>
  );
};
